export default {
  frontend_groovemail_forms_view_email: 'Email needs to be a valid email',
  frontend_groovemail_forms_view_confirm_email: 'Please confirm your email for opting in',
  frontend_cancel: 'Cancel',
  frontend_groovemail_frontend_confirm: 'Confirm',
  frontend_groovemail_settings_integeration_invalid_phone_number: 'Invalid phone number',
  frontend_send: 'Send',
  frontend_groovemail_forms_view_invalid_data: 'Invalid Data',
  frontend_close: 'Close',
  frontend_groovemail_forms_view_unknown_backend_error: 'Unknown Backend Error Occured. Please refresh and try again and if error persists, please contact support',
};
